import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMe } from '../lib/queries';
import { Spinner } from './ui';

/** Requires a signed-in user, and pushes incomplete accounts through onboarding. */
export function RequireAuth({ children, allowUnonboarded = false }: { children: ReactNode; allowUnonboarded?: boolean }) {
  const { data, isLoading } = useMe();
  const location = useLocation();

  if (isLoading) return <Spinner label="Checking your session" />;
  if (!data?.user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (!allowUnonboarded && !data.user.onboardedAt) return <Navigate to="/onboarding" replace />;

  return <>{children}</>;
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { data, isLoading } = useMe();
  if (isLoading) return <Spinner />;
  if (!data?.user) return <Navigate to="/login" replace />;
  if (!data.user.isAdmin) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

/** Sends an already-signed-in user away from the marketing and auth screens. */
export function RedirectIfAuthed({ children }: { children: ReactNode }) {
  const { data, isLoading } = useMe();
  if (isLoading) return <Spinner />;
  if (data?.user) return <Navigate to={data.user.onboardedAt ? '/dashboard' : '/onboarding'} replace />;
  return <>{children}</>;
}
